import React, { ReactNode } from "react";
import { useIntl } from "react-intl";
import { setIntl } from "./translate/i18n";

interface IntlSetupProps {
  children: ReactNode;
}

const IntlSetup: React.FC<IntlSetupProps> = ({ children }) => {
  const intl = useIntl();
  setIntl(intl);
  return <>{children}</>;
};

export default IntlSetup;
